import React, { useState } from 'react';
import { IMAGES } from '../../../config/images.js';

const AdvantagesSection = () => {
  const advantages = [
    "Разнообразие локаций и маршрутов",
    "Экономия времени на поиск новых мест",
    "Расширение своих знаний о Петербурге",
    "Современные способы планирования досуга",
    "Доступность знаний о городе"
  ];

  // Массив фотографий
  const photos = [
    IMAGES.advantages1,
    IMAGES.advantages2,
    IMAGES.advantages3,
    IMAGES.advantages4,
    IMAGES.advantages5
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const hasPrev = currentIndex > 0;
  const hasNext = currentIndex < photos.length - 1;

  const handlePrev = () => {
    if (hasPrev) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleNext = () => {
    if (hasNext) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  return (
    <section id="advantages" className="flex-column">
      <p id="advantagesHeader">ПИТЕР ДЛЯ ТЕБЯ — ЭТО</p>
      <div id="advantagesAndPhotosWrapper" className="flex-row">
        <div className="advantagesPhotos-container">
          <img 
            className="advantagesPhotos" 
            src={photos[currentIndex]} 
            alt="Преимущества"
          />
          
          <img 
            className={`arrow-l ${!hasPrev ? 'disabled' : ''}`} 
            src="/elements/arrowL.svg" 
            alt="Предыдущее"
            onClick={handlePrev}
          />
          <img 
            className={`arrow-r ${!hasNext ? 'disabled' : ''}`} 
            src="/elements/arrowR.svg" 
            alt="Следующее"
            onClick={handleNext}
          />
        </div>

        <div className="flex-column">
          <div className="allAdvantagesWrapper flex-column">
            {advantages.map((advantage, index) => (
              <div key={index} className="advantagesWrapper flex-column">
                <div className="advantagesTextDotWrapper flex-row">
                  <p className="advantagesText">{advantage}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdvantagesSection;